















































































































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import store from "@/store";
//  types
import { FeatureConfig } from "@/types/dataQuality/dataOutliers";
//  components
//  modules
import { getModule } from "vuex-module-decorators";
import DataQualityModule from "@/store/clients/DataQuality.module";
import machineModelsClient from "Clients/machine-models-client";

interface VesselMachineModelsResponse {
  vesselId: number;
  machineModels: Array<{
    id: number;
    name: string;
    coreInput: string;
    inputs: string | null;
    output: string | null;
  }>;
}

const DataQuality = getModule(DataQualityModule, store);

@Component({
  components: {},
})
export default class ThresholdsModal extends Vue {
  @PropSync("value", { required: true }) isModalActive!: boolean;
  @Prop({ type: String, default: "448px" }) width!: string;
  @Prop() readonly isDataLoading!: boolean;
  @Prop({ type: Array, default: () => [] }) featureConfigs!: FeatureConfig[];
  @Prop({ required: true, type: String }) vesselName!: string;

  featureInputDirtyList: string[] = [];
  hasModels = false;
  isCheckingModels = false;

  //  @Getters

  get vesselId(): number | null {
    return this.featureConfigs.length > 0 ? this.featureConfigs[0].vesselId : null;
  }

  get isLoading(): boolean {
    return this.isDataLoading || this.isCheckingModels;
  }

  @Watch("isModalActive")
  async onModalActiveChanged(isActive: boolean): Promise<void> {
    if (isActive && this.vesselId) {
      await this.checkVesselModels();
    }
  }

  @Watch("vesselId")
  async onVesselIdChanged(newVesselId: number | null): Promise<void> {
    if (this.isModalActive && newVesselId) {
      await this.checkVesselModels();
    }
  }

  // @Methods
  open(): void {
    this.isModalActive = true;
    this.$emit("open");
  }

  close(): void {
    this.isModalActive = false;
    this.$emit("close");
  }

  onThresholdUpperChanged(featureName: string, value: string | number) {
    if (!this.featureInputDirtyList.includes(featureName)) this.featureInputDirtyList.push(featureName);

    const config = this.featureConfigs.find(c => c.featureName === featureName);
    if (config) {
      config.upperBound = value === "" ? null : Number(value);
    }
  }

  onThresholdsLowerChanged(featureName: string, value: string | number) {
    if (!this.featureInputDirtyList.includes(featureName)) this.featureInputDirtyList.push(featureName);

    const config = this.featureConfigs.find(c => c.featureName === featureName);
    if (config) {
      config.lowerBound = value === "" ? null : Number(value);
    }
  }

  featureUnit(featureName: string): string {
    return DataQuality.features.find(feature => feature.name === featureName)?.unit.name || "n/a";
  }

  updateFeatureConfigs(): void {
    this.$emit("updateFeatureConfigs", this.featureConfigs);
    this.close();
  }

  recalculateOutliers(): void {
    this.$emit("recalculateOutliers", this.featureConfigs[0].vesselId);
    this.close();
  }

  async checkVesselModels(): Promise<void> {
    if (!this.vesselId) {
      this.hasModels = false;
      return;
    }

    this.isCheckingModels = true;
    try {
      const data: VesselMachineModelsResponse = await machineModelsClient.getVesselMachineModels(this.vesselId);
      console.log(data);
      this.hasModels = data && data.machineModels && data.machineModels.length > 0;
    } catch (error) {
      this.hasModels = false;
    } finally {
      this.isCheckingModels = false;
    }
  }

  //  @Hooks
}
